export const errorHandler = (error) => {
    try {
        return `error.response.${error.response.data.error_type}`
    } catch (e) {
        return 'error.response.undefined'
    }
}
